import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";
import { CustomerNote } from "@app/models/customer-note";
import { CustomerNotes } from '@app/models/customer-notes';

@Injectable({
    providedIn: 'root'
})
export class CustomerNoteService extends BaseRestService {

    readonly CUSTOMER_NOTE_URL: string = environment.apiUri + '/customer-note';

    getList(pageParams: any): Observable<any> {
        const options = {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams)
        }
        return this.httpClient.get(this.CUSTOMER_NOTE_URL, options);
    }

    getCustomerNoteByCode(code): Observable<any> {
        const options = {
            headers: this.headers
        }
        return this.httpClient.get(this.CUSTOMER_NOTE_URL + '/code/' + code, options);
    }

    create(data: CustomerNote): Observable<any> {
        return this.httpClient.post(this.CUSTOMER_NOTE_URL, JSON.stringify(data),
            { headers: this.headers });
    }

    update(customerNote: CustomerNote): Observable<any> {
        return this.httpClient.put(this.CUSTOMER_NOTE_URL + '/' + customerNote.id, JSON.stringify(customerNote),
            { headers: this.headers });
    }

    delete(id: string): Observable<any> {
        return this.httpClient.delete(this.CUSTOMER_NOTE_URL + "/" + id,
            { headers: this.headers });
    }

    findCustomerNoteParents(customerNote: CustomerNotes, customerNotes: Array<CustomerNotes>){
      let items = [];
      if (customerNote) {
        items.push(customerNote);
        if (customerNotes && customerNotes.length > 0) {
          var parentItem = this.findCustomerNoteById(customerNote.parentCustomerNoteId, customerNotes);
          if (parentItem) {
            items = items.concat(this.findCustomerNoteParents(parentItem, customerNotes));
          }
        }
      }
      return items;
    }
    
    findCustomerNoteById(id: string, items: Array<CustomerNotes>) {
      if (id) {
        if (items && items.length > 0) {
          var item = items.find((p) => p.id == id);
          if (item) {
            return item;
          }

          for (var i = 0; i < items.length; i++) {
            var item = this.findCustomerNoteById(id, items[i].subCustomerNotes);
            if (item) {
              return item;
            }
          }
        }
      }
      return undefined;
    }
}